import { render, staticRenderFns } from "./GetQuote.vue?vue&type=template&id=bb0c44ee&"
import script from "./GetQuote.vue?vue&type=script&lang=js&"
export * from "./GetQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports